<template>
  <div class="h100vh-116">
    <div class='h-ainfoBg'>
      <div class='h-ainfo'>
        <span class='icon hero-icon hero-icon-detailcode'></span>
        <span>{{$t('MCS.choosed')}} {{ chooseCount }} {{$t('MCS.num')}}</span>
      </div>
    </div>
    <div style="height: calc(100vh - 200px) !important;">
      <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :allowResizing='false' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='actionComplete'>
        <e-columns>
          <e-column type='checkbox' headerText='groupId' width='30' textAlign='Center'></e-column>
          <e-column field='groupId' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupNum")' width='80' textAlign='Center'></e-column>
          <e-column field='groupType' clipMode='EllipsisWithTooltip' :valueAccessor='grouptypeFormatter' :headerText='$t("MCS.groupType")' width='40' textAlign='Center'></e-column>
          <e-column field='groupAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupAlias")' width='180' textAlign='Center'></e-column>
          <e-column field='groupOwner' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupOwner")' width='180' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='addGroupPage' :element='dialog.element.eleAddGroup' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <AddGroupDialog ref='addGroup' opCode='0' :neid='neid' :vpnId='vpnId'></AddGroupDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='modGroupPage' :element='dialog.element.eleModGroup' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <AddGroupDialog ref='modGroup' opCode='1' :neid='neid' :vpnId='vpnId'></AddGroupDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='groupAreaPage' :element='dialog.element.eleGroupArea' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <GroupArea ref='groupArea' :neid='neid'></GroupArea>
      </template>
    </CustomDialog>
    <CustomDialog ref='addGroupMemberPage' :element='dialog.element.eleAddGroupMember' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <AddGroupMemberDialog ref='addGroupMember' :neid='neid' :vpnId='vpnId' :vpnClass='vpnClass'></AddGroupMemberDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='qryGroupMemberPage' :element='dialog.element.eleModGroupMember' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <QryGroupMemberDialog ref='qryGroupMember' :neid='neid' :vpnId='vpnId'></QryGroupMemberDialog>
      </template>
    </CustomDialog>
    <div v-if="gpsVif" class='h-pop-container'>
      <div class='h-pop-inside'>
        <div class='h-pop-top'>
          <div class='h-pop-title'>
            <div class='h-pop-height15d2'></div>
            <span style="font-size: 13px; font-weight: bold; color: #5a5a5a">{{$t('MCS.gpsGroupCallManage')}}</span>
          </div>
          <div class="h-pop-close">
            <div class='h-pop-height15d2'></div>
              <span class="e-btn-icon icon hero-icon hero-icon-remove-small h-pop-closeIcon" @click='closeGpsGroupCallPage'></span>
          </div>
        </div>
        <div class='h-pop-mid'>
          <GpsGroupCallDialog ref='gpsGroupCall' :vpnId='vpnId'></GpsGroupCallDialog>
        </div>
        <div class='h-pop-bottom'>
          <div class="e-dialog">
            <div class="e-footer-content">
              <button type="button" class="e-control e-btn e-lib e-flat" data-ripple="true" @click='closeGpsGroupCallPage'>{{$t('MCS.cancle')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomDialog ref='superSearchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch'>
      <template v-slot:dialog-content>
        <SuperSearch ref='superSearch' :neid='neid' :userNumValue='userNumSearch' :reFreshGrid='reFreshGrid'></SuperSearch>
      </template>
    </CustomDialog>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { Edit, Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../../common/CustomDialog';
import AddGroupDialog from './dialog/AddGroupDialog';
import GroupArea from './dialog/GroupArea';
import AddGroupMemberDialog from './dialog/AddGroupMemberDialog';
import QryGroupMemberDialog from './dialog/QryGroupMemberDialog';
import GpsGroupCallDialog from './dialog/GpsGroupCallDialog';
import SuperSearch from './dialog/SearchGroupDialog';
import DialogList from '../../../subscriberconfig/util/tipDialog/DialogList';
import commonJS from '../common';
import { EventBus } from "../../../../plugins/eventBus";

export default {
  name: 'GroupTable',
  props:[
    'qryNeids'
  ],
  components: {
    CustomDialog,
    AddGroupDialog,
    GroupArea,
    AddGroupMemberDialog,
    QryGroupMemberDialog,
    GpsGroupCallDialog,
    SuperSearch,
    DialogList
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      gpsVif: false,
      groupId: '',
      userNumSearch: '',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      neid: '',
      vpnId: 6,
      vpnClass: 1,
      equipmentIPId: '',
      vo: {
        flag: '',
        participantType: ''
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          model: true,
          visible: false
        },
        stylesGroupList: {
          width: '30%',
          height: '80%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '400px',
          height: '270px',
          visible: false,
          model: true
        },
        element: {
          eleAddGroup: {
            target: this.$refs.userstable,
            refName: 'eleAddGroup',
            buttonGroup: [
              { click: this.closeAddGroupPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveAddGroup, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.addGroup'),
            isClose: true
          },
          eleModGroup: {
            target: this.$refs.userstable,
            refName: 'eleModGroup',
            buttonGroup: [
              { click: this.closeModGroupPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveModGroup, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.modGroup'),
            isClose: true
          },
          eleGroupArea: {
            target: this.$refs.userstable,
            refName: 'eleGroupArea',
            buttonGroup: [
              { click: this.closeGroupAreaPage, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.addAreaNum'),
            isClose: true
          },
          eleAddGroupMember: {
            target: this.$refs.userstable,
            refName: 'eleAddGroupMember',
            buttonGroup: [
              { click: this.closeAddGroupMemberPage, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.addGroupMember'),
            isClose: true
          },
          eleModGroupMember: {
            target: this.$refs.userstable,
            refName: 'eleModGroupMember',
            buttonGroup: [
              { click: this.closeQryGroupMemberPage, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.groupMemberManage'),
            isClose: true
          },
          eleSearch: {
            target: this.$refs.userstable,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closenSuperSearchPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveSuperSearch, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.superSearch'),
            isClose: true
          },
        },
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          { click: this.closeDialogListTipPage, buttonModel: { content: this.$t('MCS.cancle') } }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  methods: {
    getGridData(node = null, firstPageFlag = false) {
      const $this = this;
      let pageNo = $this.$refs.pager.ej2Instances.currentPage;
      if (node !== null) {
        const array = node.id.split('_');
        const gmsNeid = array[0];
        const vpnId = array[2];
        const vpnClass = parseInt(node.level, 0) - 1;
        $this.neid = gmsNeid;
        $this.vpnId = vpnId;
        $this.vpnClass = vpnClass;
        $this.equipmentIPId = node.neNode.equipmentIPId;
        pageNo = 1;
        this.clearCondition();
      }
      if (firstPageFlag === true) {
        pageNo = 1;
        $this.$refs.pager.ej2Instances.goToPage(1);// 高级搜索时默认显示第一页的结果
      }
      const vo = {
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        groupId: this.userNumSearch,
        vpnId: $this.vpnId,
        vpnClass: $this.vpnClass,
        flag: 2,
      };
      const params = {
        info: this.setInfo(this.msg.qryGroups),
        vo: vo,
        page: {
          pageNo: pageNo,
          pageSize: this.page.pageSize
        }
      };
      EventBus.$emit('loading', { ison: true });
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data;
        const resData = res.resultVal.result;
        EventBus.$emit('loading', { ison: false });
        $this.data = resData;
        $this.page.totalCount = res.resultVal.totalCnt;
        $this.$refs.grid.clearSelection();
      });
    },

    isChooseNe() {
      if (this.neid === '') {
        this.$toast('warning', this.$t('MCS.chooseNe'));
        return false;
      }
      return true;
    },

    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        this.$toast('warning', this.$t('MCS.onlyData'));
        return false;
      }
      return selectedRecords;
    },

    getCheckedVals(selectOnly = false) {
      const groupId = [];
      if (this.isChooseNe() !== false) {
        // x-> false: 不支持多选   true: 支持多选
        const checkedData = this.getCheckedData(selectOnly);
        for (let i = 0; i < checkedData.length; i++) {
          groupId.push(checkedData[i].groupId);
        }
      }
      return groupId;
    },

    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },

    actionComplete(){
      this.$refs.grid.selectRow(0,true);
      this.$refs.grid.selectRow(0,true);
    },

    /**
     * 打开/关闭/保存  添加群组页面
     */
    openAddGroupPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      if (parseInt(this.vpnId) === 0) {
        this.$toast('failure', this.$t('MCS.vpn0CantAddGroup'));
        return;
      }
      const data = {
        vpnId: this.vpnId
      };
      this.$refs.addGroup.mainHandler(data);
      this.$refs.addGroupPage.show();
    },
    closeAddGroupPage() {
      this.$refs.addGroupPage.clear();
      this.$refs.addGroupPage.close();
    },
    saveAddGroup() {
      const $this = this;
      const datas = this.$refs.addGroup.getDatas();
      datas.vpnId = $this.vpnId;
      if (datas === false)  return;
      const params = {
        vo: datas,
        info: this.setInfo(this.msg.addGroup),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.addGroup',
          exectype: 1,
          execData: [datas.groupId]
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        this.getGridData();
      });
      this.$refs.addGroupPage.clear();
      this.$refs.addGroupPage.close();
    },

    /**
     * 打开/关闭/保存  修改群组页面
     */
    openModGroupPage() {
      const $this = this;
      const groupId = $this.getCheckedVals();
      if (groupId.length !== 0) {
        const vo = {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          groupId: groupId[0],
          flag: 1,
          vpnId: $this.vpnId,
          vpnClass: $this.vpnClass
        };
        const page = {
          pageNo: 1,
          pageSize: 15
        };
        const params = {
          info: $this.setInfo($this.msg.qryModGroup),
          vo: vo,
          page: page
        };
        $this.$axios.post($this.requestCommon, params).then((response) => {
          const data = response.data.resultVal.result[0];
          $this.$refs.modGroup.mainHandler(data);
          $this.$refs.modGroupPage.show();
        });
      }
    },
    closeModGroupPage() {
      this.$refs.modGroupPage.clear();
      this.$refs.modGroupPage.close();
    },
    saveModGroup() {
      const $this = this;
      const datas = $this.$refs.modGroup.getDatas();
      if (datas === false)  return;
      const params = {
        vo: datas,
        info: $this.setInfo($this.msg.modGroup),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.modGroup',
          exectype: 1,
          execData: [datas.groupId]
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        $this.commonResp(response);
        this.getGridData();
      });
      this.$refs.modGroupPage.clear();
      this.$refs.modGroupPage.close();
    },

    /**
     * 删除群组
     */
    delGroups() {
      const $this = this;
      const groupId = this.getCheckedVals(true);
      if (groupId.length === 0) {
        return;
      };
      this.$layer.confirm({
        msg: this.$t('MCS.deleteConfirm'),
        btn1: {
          msg: this.$t('MCS.cancle')
        },
        btn2: {
          msg: this.$t('MCS.confirm'),
          func: () => {
            const params = {
              info: {
                neid: this.neid,
                msgid: this.msg.delGroup,
              },
              vo: {
                enterpriseDomain: $this.enterpriseDomain,
                productType: $this.productType,
                opCount: groupId.length,
                groupId: groupId
              },
              log: {
                module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
                execFunName: 'subscriber.delGroup',
                exectype: 1,
                execData: groupId
              }
            };
            this.$axios.post(this.requestCommon, params).then((response) => {
              $this.commonResp(response);
              $this.getGridData(null, true);
            });
          }
        }
      });
    },

    openGroupAreaPage() {
      const groupId = this.getCheckedVals();
      if (groupId.length === 0) {
        return;
      }
      this.$refs.groupArea.getGridData(groupId[0]);
      this.$refs.groupAreaPage.show();
    },
    closeGroupAreaPage() {
      this.$refs.groupAreaPage.clear();
      this.$refs.groupAreaPage.close();
    },

    /**
     * 打开/关闭/保存  添加组成员页面
     */
    openAddGroupMemberPage() {
      const groupId = this.getCheckedVals();
      if (groupId.length === 0) {
        return;
      }
      if (groupId.length !== 0) {
        this.$axios.post('/lte/ems/auth/findElementListByAuth', [2110]).then((response) => {
          response.data.forEach((item) => {
            if (item.equipmentIPId === this.equipmentIPId) {
              this.$refs.addGroupMember.getGridData(groupId[0], item.id);
              this.$refs.addGroupMemberPage.show();
              return false;
            }
            return true;
          });
        });
      }
      this.$refs.addGroupMemberPage.show();
    },
    closeAddGroupMemberPage() {
      this.$refs.addGroupMemberPage.clear();
      this.$refs.addGroupMemberPage.close();
    },
    saveAddGroupMember() {
    },

    /**
     * 打开/关闭/保存  组成员管理页面
     */
    openQryGroupMemberPage() {
      const groupId = this.getCheckedVals();
      if (groupId.length !== 0) {
        this.$refs.qryGroupMember.getGridData(groupId[0]);
        this.$refs.qryGroupMemberPage.show();
      }
    },
    closeQryGroupMemberPage() {
      this.$refs.qryGroupMemberPage.clear();
      this.$refs.qryGroupMemberPage.close();
    },
    saveQryGroupMember() {
    },

    /**
     * 打开/关闭/保存  呼叫区域管理
     */
    openGpsGroupCallPage() {
      const groupId = this.getCheckedVals();
      const grouptype = this.$refs.grid.getSelectedRecords()[0].groupType;
      if (grouptype !== '2') {
        this.$toast('warning', this.$t('MCS.chooseAreaGroup'));
        return ;
      };
      if (groupId.length !== 0) {
        this.groupId = groupId[0];
        this.gpsVif = true;
        this.$forceUpdate();
      };
    },
    closeGpsGroupCallPage() {
      this.gpsVif = false;
    },

    /**
     * 打开/关闭/保存  高级搜索页面
     */
    openSuperSearchPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.superSearchPage.show();
      this.$refs.superSearch.bindValidate();
    },
    closenSuperSearchPage() {
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },
    saveSuperSearch() {
      debugger
      if (!this.$refs.superSearch.checkValid()) {
        return;
      }
      this.$refs.superSearch.search();
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },

    setInfo(msgid) {
      return {
        msgid: msgid,
        neid: this.neid,
      };
    },

    clearCondition() {
      this.userNumSearch = '';
      this.$refs.superSearch.setData('');
    },

    reFreshByNoCondition() {
      debugger
      this.clearCondition();
      this.getGridData();
    },

    reFreshGrid(userNum) {
      debugger
      this.userNumSearch = userNum;
      this.getGridData(null, true);
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

    exportGroupData() {
      const checkedDatas = this.getCheckedVals(true);

      if (checkedDatas.length == 0) {
        return;
      }

      const paramsOfGroup = {
        info: {
          neid: this.neid,
          operation: 'batchGroupExport'
        },
        vo: {
          0: {
            vo: {
              enterpriseDomain: this.enterpriseDomain,
              flag: 1,
              groupId: checkedDatas,
              productType: this.productType,
              vpnClass: this.vpnClass,
              vpnId: this.vpnId
            },
            info: {
              neid: this.neid,
              msgid: this.msg.qryModGroup
            },
            page: {
              pageNo: 1,
              pageSize: 30
            }
          }
        }
      };

      const paramsOfVpn = {
        info: {
          neid: this.qryNeids,
          operation: 'getVpnTreeWithNeid'
        },
        vo: {
          0: {
            vo: {
              enterpriseDomain: this.enterpriseDomain,
              flag:0,
              neid: this.qryNeids,
              productType: this.productType,
              vpnId:""
            },
            info: {
              enterpriseDomain: this.enterpriseDomain,
              msgid: this.msg.qryVpnId,
              neid: this.qryNeids,
              productType: this.productType
            },
            page: {
              page:1,
              count:400
            }
          }
        }
      }

      const params = {
        paramsCommon: paramsOfGroup,
        paramOfVpn: paramsOfVpn
      }

      const config = {
        responseType: 'blob'
      };
      this.$loading.showLoadding(this.$t('SubscriberIms.exportdata'),this.$t('SubscriberIms.waitTip'));
      this.$axios.post(`/lte/ems/subscriber/mcs/batch/batchExport.html?exportType=2&searchVpnId=${this.neid}&neid=${this.neid}&msgid=46080`, params, config).then((res) => {
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        const dateStr = new Date().Format('yyyyMMdd_HH-mm');
        const fileName = `${this.$t('SubscriberIms.group')}_${dateStr}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$loading.hideLoadding();
      });
    },

    exportGroupMemberData() {
      const checkedDatas = this.getCheckedVals(true);

      if (checkedDatas.length == 0) {
        return;
      }

      const paramsOfGroupMember = {
        info: {
          neid: this.neid,
          operation: 'batchGroupMemberExport'
        },
        vo: {
          0: {
            vo: {
              enterpriseDomain: this.enterpriseDomain,
              flag: 0,
              groupId: checkedDatas,
              productType: this.productType,
              vpnId: 0
            },
            info: {
              neid: this.neid,
              msgid: this.msg.qryGroupMember
            },
            page: {
              pageNo: 1,
              pageSize: 150000
            }
          }
        }
      };

      const params = {
        paramsCommon: paramsOfGroupMember
      }

      const config = {
        responseType: 'blob'
      };
      this.$loading.showLoadding(this.$t('SubscriberIms.exportdata'),this.$t('SubscriberIms.waitTip'));
      this.$axios.post(`/lte/ems/subscriber/mcs/batch/batchExport.html?exportType=3&searchVpnId=${this.neid}&neid=${this.neid}&msgid=46085`, params, config).then((res) => {
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        const dateStr = new Date().Format('yyyyMMdd_HH-mm');
        const fileName = `${this.$t('MCS.groupMember')}_${dateStr}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$loading.hideLoadding();
      });
    }

  },
  provide: {
    grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu]
  },
};
</script>

<style scoped>

</style>
